import { render, staticRenderFns } from "./view-item-relation-to-one.vue?vue&type=template&id=7d1f529c&"
import script from "./view-item-relation-to-one.vue?vue&type=script&lang=js&"
export * from "./view-item-relation-to-one.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports